const initState = {
    basename: "/auditor"
}

export default function routingReducer(state = initState, action) {
    return state
}